Selectize.define('delete_item_button', function(options) {
	options = $.extend({
		cssClass: 'selectize-delete-item-button',
		onDelete: function() {},
		canDelete: function() { return true; }
	}, options);
	var self = this;
	var html = '<a class="btn ' + options.cssClass + '" data-remove-button><span class="glyphicons glyphicons-remove-2" /></a>';

	var append = function(html_container, html_element) {
		var pos = html_container.search(/(<\/[^>]+>\s*)$/);
		return html_container.substring(0, pos) + html_element + html_container.substring(pos);
	}

	this.setup = (function() {
		var original = self.setup;
		return function() {
			var canDelete = options.canDelete;
			var render_option = self.settings.render.option;
			self.settings.render.option = function(data) {
				if(canDelete(data))
					return append(render_option.apply(this, arguments), html);
				return render_option.apply(this, arguments);
			};

			original.apply(this, arguments);

			this.$dropdown.on('mousedown', '*[data-remove-button]', function(e) {
				e.stopPropagation();
				e.preventDefault();
				var parent = $(e.currentTarget).parent();
				var value = parent.attr('data-value');
				self.removeOption(value);
				self.refreshOptions(true);
				options.onDelete(value);
			});
		};
	})();
});